import type { RuleDefinition } from '../domain/types';
import { getCellText } from '../domain/cells';
import { isMeaningfulDescription } from '../utils/text';
import { finding } from './helpers';

export const BQ004: RuleDefinition = {
  id: 'BQ004',
  name: '项目特征缺失或过短',
  description: '检查项目特征是否为空、仅含无意义符号或短于设置的有效长度。',
  defaultSeverity: 'warning',
  enabled: true,
  applicableFields: ['description'],
  message: '项目特征缺失或内容过短，无法提供足够的人工复核线索。',
  suggestion: '请结合原清单补充有意义的项目特征描述，或关闭本规则。',
  check: ({ detailRows, settings }) =>
    detailRows
      .filter(
        (row) =>
          !isMeaningfulDescription(
            getCellText(row, 'description'),
            settings.minimumDescriptionLength,
          ),
      )
      .map((row) => finding(row, 'description')),
};
